export enum ShipmentStatus {
  ALL = '',
  CANCELLED = 'Cancelled',
  CANCELLING = 'Cancelling',
  DELIVERED = 'Delivered',
  IN_PROGRESS = 'In Progress',
}

export interface GeneralShipment {
  id: number;
  creationDate: string;
  shipmentId: string;
  userEmail: string;
  originCity: string;
  destinationCity: string;
  reference1: string;
  reference2: string;
  status: ShipmentStatus;
}

export interface AdminShipment extends GeneralShipment {
  ffNumber: string;
}

export interface GeneralShipmentsQueryPayload {
  shipmentStartDate: Date | null;
  shipmentEndDate: Date | null;
  userEmail: string;
  selectedJob: string;
  subAccountNumber: string;
  search: string;
  status: ShipmentStatus;
  page: number;
  pageSize: number;
}
